module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    staticClass: "project-update"
  }, [_c('div', {
    staticClass: "wizard-toolbar"
  }, [_c('div', {
    staticClass: "grid-2"
  }, [_c('div', {
    staticClass: "progress-step-1 done"
  }, [_c('div', {
    staticClass: "bar"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.project_wizard.step1-title')))])]), _vm._v(" "), _c('div', {
    staticClass: "progress-step-2 done"
  }, [_c('div', {
    staticClass: "bar"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.project_wizard.step2-title')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "project-created"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../assets/project-created.svg")
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('ui.project_wizard.success-title')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.project_wizard.success-subtitle')))])]), _vm._v(" "), _c('div', {
    staticClass: "actions wizard-footer"
  }, [(_vm.shouldShowDefaultActions) ? _c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'project_leads',
        params: {
          id: this.item.id.toString()
        }
      }
    }
  }, [_c('a', {
    staticClass: "cancel"
  }, [_vm._v(_vm._s(_vm.$t('ui.pages.project-capture-leads')))])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'content_manager'
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat btn-save"
  }, [_vm._v(_vm._s(_vm.$t('ui.pages.project-create-content')))])])], 1) : _c('div', {
    staticClass: "actions"
  }, [_c('a', {
    attrs: {
      "href": _vm.talentKitLink
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat btn-save"
  }, [_vm._v("\n            " + _vm._s(_vm.$t(_vm.talentButtonText)) + "\n          ")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'project_leads',
        params: {
          id: this.item.id.toString()
        }
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat btn-save"
  }, [_vm._v(_vm._s(_vm.$t('ui.pages.project-capture-leads')))])])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e99f3096","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/projects/wizard/Success.vue
// module id = 2007
// module chunks = 0